import React, { useEffect } from 'react';
import customEventBus from '@common/scripts/libs/eventBus';
const EventBusWrapper = (events) => {
    useEffect(() => {
        const triggerWishlistUpdate = (e) => {
            console.log(e);
            customEventBus.emit('wishlist:update', e.detail);
        };
        const triggerAccountUpdate = (e) => {
            customEventBus.emit('account:update', e.detail);
        };
        document.addEventListener('wishlist:update', triggerWishlistUpdate);
        document.addEventListener('account:update', triggerAccountUpdate);
        return () => {
            document.removeEventListener('wishlist:update', triggerWishlistUpdate, false);
            document.removeEventListener('account:update', triggerAccountUpdate, false);
        };
    }, []);
    return React.createElement(React.Fragment, null);
};
export default EventBusWrapper;
